import type { FetchItemWrapperProps } from "./fetch-item-wrapper.type";

import { Spin } from "antd";
import { useTranslation } from "react-i18next";

const FetchItemWrapper = <Item extends object>({
  item,
  loading,
  renderContent,
}: FetchItemWrapperProps<Item>) => {
  const { t } = useTranslation();

  if (loading) return <Spin data-testid="fetch-item-loader" />;

  if (!item) return t("form:error.genericError");

  return renderContent(item);
};

export default FetchItemWrapper;
